import "@/App.css";
import { AnimatePresence } from "framer-motion";
import { RotateCcw } from "lucide-react";
import { Toaster } from "sonner";
import { useAlterEgoChat } from "@/hooks/useAlterEgoChat";
import { SetupSection } from "@/components/SetupSection";
import { ChatSection } from "@/components/ChatSection";

function App() {
  const { decision, messages, isStreaming, error, startChat, sendMessage, stopReply, retry, reset } = useAlterEgoChat();
  const inChat = Boolean(decision) && (messages.length > 0 || isStreaming);
  const startFailed = Boolean(decision) && !inChat;

  return (
    <div className="app-shell">
      <div className="h-screen flex flex-col relative z-10">
        <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#07080C]/80 border-b border-[#1E2333] px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="font-heading font-bold text-base tracking-tight text-white">Other Self</span>
            <span data-testid="timeline-status-badge" className="hidden sm:inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-[#94a3b8] border border-[#1E2333] rounded-full px-3 py-1">
              <span className="pulse" />
              {inChat ? "timeline linked" : "awaiting fork"}
            </span>
          </div>
          {(inChat || startFailed) && (
            <button data-testid="reset-chat-button" className="btn-ghost" onClick={reset}>
              <RotateCcw size={13} /> Reset & Start New
            </button>
          )}
        </header>

        <AnimatePresence mode="wait">
          {inChat ? (
            <ChatSection key="chat" decision={decision} messages={messages} isStreaming={isStreaming} error={error} onSend={sendMessage} onStop={stopReply} onRetry={retry} />
          ) : (
            <SetupSection key="setup" onStart={startChat} error={startFailed ? error : null} onRetry={retry} />
          )}
        </AnimatePresence>
      </div>
      <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#131622", border: "1px solid #1E2333", color: "#f8fafc" } }} />
    </div>
  );
}

export default App;
